import { isAxiosError } from "axios";
import type { QueryClient } from "@tanstack/react-query";

export function householdError(error: unknown): string {
  if (isAxiosError(error) && typeof error.response?.data?.detail === "string") return error.response.data.detail;
  if (error instanceof Error && !isAxiosError(error)) return error.message;
  return "Unable to save your changes. Please try again.";
}

export async function refreshHouseholdQueries(client: QueryClient, churchId: string) {
  await Promise.all(["households", "household", "household-summary", "household-intelligence", "household-deletion-status", "members", "member", "dashboard", "global-search"].map(key =>
    client.invalidateQueries({ queryKey: [key, churchId] })
  ));
}
